import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// Create axios instance with interceptors
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const fetchUsers = createAsyncThunk(
  'users/fetchUsers',
  async ({ page = 1, limit = 10, search = '', status = '' }) => {
    try {
      const response = await api.get(`/api/users?page=${page}&limit=${limit}&search=${encodeURIComponent(search)}&status=${status}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const fetchUserById = createAsyncThunk(
  'users/fetchUserById',
  async (id) => {
    try {
      const response = await api.get(`/api/users/${encodeURIComponent(id)}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const createUser = createAsyncThunk(
  'users/createUser',
  async (userData) => {
    try {
      const response = await api.post('/api/users', userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const updateUser = createAsyncThunk(
  'users/updateUser',
  async ({ id, userData }) => {
    try {
      const response = await api.put(`/api/users/${encodeURIComponent(id)}`, userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);

export const deleteUser = createAsyncThunk(
  'users/deleteUser',
  async (id) => {
    try {
      await api.delete(`/api/users/${encodeURIComponent(id)}`);
      return id;
    } catch (error) {
      throw error.response?.data || error.message;
    }
  }
);
